import {
  GET_STORY_URL
} from 'shared/utils/Constants';

import { get } from 'shared/services/ApiService';

import { print, printError } from 'shared/utils/Helpers';
import User from 'shared/data/User';

// eventually the kiosk & consumer app can use these directly.
// this UserService class has become a bit antiquated
import {
  me,
  login,
  logout,
  register,
  requestPasswordReset,
  passwordResetLogin,
  updatePassword,
  updateUserName,
  updateMFAInfo,
  setLocale,
  getAccessCode
} from 'shared/services/user';

// this class is old and can be removed,
// and the service functions above can be used instead.
// the kiosk and consumer app would need to be updated,
// and the localStorage stuff will need to be looked at.
// the user session can be handled without it, but it might be hooked up
export default class UserService {
  async me() {
    return me()
      .then(user => {
        User.instance.save(user);
        return Promise.resolve(user);
      })
      .catch(() => {
        return Promise.resolve(null);
      });
  }

  async signInWithCredentials(email, password) {
    return login(email,password)
      .then(resp => {
        User.instance.save(resp);
        return Promise.resolve(resp);
      }).catch(resp => {
        if ("error" in resp) {
          return Promise.reject(resp["error"]);
        }
      });
  }

  async logout() {
    return await logout();
  }

  async register(email, password) {
    return await register(email, password);
  }

  async requestPasswordReset(params) {
    return await requestPasswordReset(params);
  }

  async passwordResetLogin(params) {
    return await passwordResetLogin(params);
  }

  async updatePassword(params) {
    return await updatePassword(params);
  }

  async updateUserName(params) {
    return await updateUserName(params);
  }

  async updateMFAInfo(params) {
    return await updateMFAInfo(params);
  }

  async getAccessCode() {
    return await getAccessCode();
  }

  async setLocale(locale) {
    return await setLocale(locale);
  }

  // the localStorage stuff is very old and I'm not sure if its being used.
  // maybe by the consumer app.
  // it's not needed since the cookie will keep the session.
  // same goes for getAuthToken, this is now covered by the ApiService
  getUser() {
    let data = localStorage.getItem('loggedInUser');
    if (data) {
      return JSON.parse(data);
    }
    return {};
  }

  getAuthToken() {
    var loggedInUser = JSON.parse(localStorage.getItem("loggedInUser"));
    if (loggedInUser && loggedInUser.token) {
      return loggedInUser.token;
    }
    return "";
  }
}
